if (!customElements.get('obr-tool-finder')) {
  class OBRToolFinder extends HTMLElement {
    connectedCallback() {
      if (this.dataset.initialized === 'true') return;
      this.dataset.initialized = 'true';
      this.tabs = Array.from(this.querySelectorAll('[data-tool-finder-tab]'));
      this.panels = Array.from(this.querySelectorAll('[data-tool-finder-panel]'));
      this.status = this.querySelector('[data-tool-finder-status]');

      this.tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => this.select(tab.dataset.toolFinderTab));
        tab.addEventListener('keydown', (event) => this.onKeydown(event, index));
      });

      this.addEventListener('shopify:block:select', (event) => {
        const tab = event.target.closest('[data-tool-finder-tab]');
        if (tab) this.select(tab.dataset.toolFinderTab, false);
      });
    }

    select(id, announce = true) {
      const selectedTab = this.tabs.find((tab) => tab.dataset.toolFinderTab === id);
      const selectedPanel = this.panels.find((panel) => panel.dataset.toolFinderPanel === id);
      if (!selectedTab || !selectedPanel) return;

      this.tabs.forEach((tab) => {
        const active = tab === selectedTab;
        tab.classList.toggle('is-active', active);
        tab.setAttribute('aria-selected', active ? 'true' : 'false');
        tab.tabIndex = active ? 0 : -1;
      });

      this.panels.forEach((panel) => {
        const active = panel === selectedPanel;
        panel.classList.toggle('is-active', active);
        panel.hidden = !active;
      });

      if (announce && this.status) {
        const model = selectedPanel.querySelector('.obr-tool-finder__model')?.textContent.trim();
        this.status.textContent = model ? `Recommendation updated: ${model}` : 'Recommendation updated';
      }
    }

    onKeydown(event, index) {
      const keys = ['ArrowDown', 'ArrowRight', 'ArrowUp', 'ArrowLeft', 'Home', 'End'];
      if (!keys.includes(event.key) || this.tabs.length < 2) return;
      event.preventDefault();

      let nextIndex = index;
      if (event.key === 'Home') nextIndex = 0;
      if (event.key === 'End') nextIndex = this.tabs.length - 1;
      if (event.key === 'ArrowDown' || event.key === 'ArrowRight') nextIndex = (index + 1) % this.tabs.length;
      if (event.key === 'ArrowUp' || event.key === 'ArrowLeft') nextIndex = (index - 1 + this.tabs.length) % this.tabs.length;

      const nextTab = this.tabs[nextIndex];
      this.select(nextTab.dataset.toolFinderTab);
      nextTab.focus();
    }
  }

  customElements.define('obr-tool-finder', OBRToolFinder);
}
